<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">{{ title }}</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Nombre (*) </label>

                <el-input v-model="formData.name" v-validate="modelValidations.name" name="name" placeholder="Nombre">
                </el-input>

                <small v-show="name.invalid" class="text-danger">
                  {{ getError('name') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Email (*) </label>

                <el-input v-model="formData.email" v-validate="modelValidations.email" name="email" placeholder="Email">
                </el-input>

                <small v-show="email.invalid" class="text-danger">
                  {{ getError('email') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Dirección (*) </label>

                <el-input
                  v-model="formData.address"
                  v-validate="modelValidations.address"
                  name="address"
                  placeholder="Dirección"
                >
                </el-input>

                <small v-show="address.invalid" class="text-danger">
                  {{ getError('address') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Teléfono (*) </label>

                <el-input
                  v-model="formData.phone"
                  v-validate="modelValidations.phone"
                  name="phone"
                  placeholder="Teléfono"
                >
                </el-input>

                <small v-show="phone.invalid" class="text-danger">
                  {{ getError('phone') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Porcentaje de Comisión (*) </label>

                <el-input
                  v-model="formData.commission"
                  v-validate="modelValidations.commission"
                  name="commission"
                  placeholder="Porcentaje de Comisión"
                  suffix-icon="fas fa-percent"
                >
                </el-input>

                <small v-show="commission.invalid" class="text-danger">
                  {{ getError('commission') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Provincia (*) </label>

                <el-select
                  v-model="formData.province"
                  v-validate="modelValidations.province"
                  autocomplete="off"
                  filterable
                  name="province"
                  placeholder="Provincia"
                  @change="clearCity"
                >
                  <el-option
                    v-for="option in provincesOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="province.invalid" class="text-danger">
                  {{ getError('province') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label d-block"> Localidad (*) </label>

                <el-autocomplete
                  v-model="formData.cityName"
                  v-validate="modelValidations.city"
                  :disabled="!formData.province"
                  name="city"
                  class="w-100"
                  placeholder="Localidad"
                  :fetch-suggestions="querySearchAsync"
                  @select="selectCity"
                >
                </el-autocomplete>

                <small v-show="city.invalid" class="text-danger d-block">
                  {{ getError('city') }}
                </small>

                <small v-show="searchError !== ''" class="text-danger d-block">
                  {{ searchError }}
                </small>
              </div>
            </div>

            <server-error :server-errors="serverErrors"></server-error>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Autocomplete } from 'element-ui';
import cityProvinceOptionsMixin from '@/mixins/cityProvinceOptionsMixin';
import { mapFields } from 'vee-validate';
import ServerError from '../../../components/ServerError';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    ServerError,
  },

  mixins: [cityProvinceOptionsMixin],
  props: {
    serverErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },

    seller: {
      type: Object,
      default: () => {
        return {
          name: null,
          province: null,
          city: null,
          cityName: null,
          address: '',
          email: '',
          phone: '',
          commission: '',
        };
      },
    },

    title: {
      type: String,
      default: 'Agregar un nuevo Asesor Técnico',
    },
  },

  data() {
    return {
      validated: false,
      formData: {
        name: this.seller.name,
        email: this.seller.email,
        province: null,
        city: null,
        address: this.seller.address,
        phone: this.seller.phone,
        commission: this.seller.commission,
      },

      modelValidations: {
        name: {
          required: true,
          min: 5,
        },

        email: {
          required: true,
          email: true,
        },

        province: {
          required: true,
        },

        city: {
          required: true,
        },

        address: {
          required: true,
        },

        phone: {
          required: true,
          numeric: true,
          min: 10,
        },

        commission: {
          required: true,
          decimal: 2,
          max: 100,
        },
      },
    };
  },

  computed: {
    ...mapFields(['name', 'province', 'city', 'address', 'email', 'phone', 'commission']),
  },

  mounted() {
    if (this.seller.city) {
      this.defaultCity = this.seller.city.id;
      this.defaultCityName = this.seller.city.name;
      this.defaultProvince = this.seller.city.province.id;
    }
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
